"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SAMSURVEYOR_COOKIE_DOMAIN = void 0;
exports.sessionCookieDomain = sessionCookieDomain;
/**
 * Which cookie domain this page is allowed to write.
 *
 * The idle clock is shared between tabs through a cookie, and the tabs sit on
 * different subdomains: console.samsurveyor.com, designer.samsurveyor.com and
 * so on. A cookie scoped to the parent domain reaches all of them.
 *
 * But a browser refuses a cookie for a domain the page is not on, and it
 * refuses silently. So asking for `samsurveyor.com` from localhost, or from one
 * of the `*.run.app` hosts, does not produce a host-scoped cookie as a
 * fallback. It produces no cookie at all, and the idle clock would never move.
 *
 * Ask for the parent domain only where it can work. Everywhere else, return
 * null and let the cookie be scoped to this host. A host-scoped clock still
 * works; it just does not reach sibling subdomains, which on localhost is
 * exactly right because there are no siblings.
 *
 * SuperPanel passes null on purpose. Its session is its own — its server
 * rewrites the Hanko cookie domain away — so its idle clock must not be shared
 * with the Console family either.
 */

const SAMSURVEYOR_COOKIE_DOMAIN = exports.SAMSURVEYOR_COOKIE_DOMAIN = 'samsurveyor.com';

/**
 * @param {string} [parent]  the parent domain to use when we are on it.
 * @param {string} [host]    defaults to the current page's hostname.
 * @returns {string|null}    the domain to write, or null for host-scoped.
 */
function sessionCookieDomain(parent = SAMSURVEYOR_COOKIE_DOMAIN, host = undefined) {
  const hostname = host !== undefined ? String(host || '') : typeof window !== 'undefined' && window.location && window.location.hostname || '';
  if (!parent || !hostname) return null;
  if (hostname === parent) return parent;
  if (hostname.endsWith(`.${parent}`)) return parent;
  return null;
}
var _default = exports.default = sessionCookieDomain;